
import { reactive, ref, toRefs, unref, onMounted, defineComponent } from "vue";
//引入vue方法
import { useStore } from "vuex";
import { ElMessage } from "element-plus";

import { ElConfigProvider } from "element-plus";
//中文包
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { getLogsList } from "@/api/backstage";
import { MenuModel } from "@/model/menuModel";
import { getEnum } from "@/api/index";

import { ElForm } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "系统日志",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    let locale = zhCn;
    const ruleFormRef = ref(ElForm);
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      tableData: [],
      total: 0,
      form: {
        time: "",
        keyword: "",
        start: "",
        end: "",
        pageNum: 1,
        pageSize: 10,
      },
      async getList() {
        let query: any =  JSON.parse(JSON.stringify(dataMap.form));
        query.time= '';
        const data = await getLogsList(query);
        dataMap.tableData = data?.data.list ?? [];
        dataMap.total = data?.data.total ?? 0;
      },
    });
    const onSubmit = () => {
      dataMap.getList();
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      dataMap.form.start = '';
      dataMap.form.end = '';
      formEl.resetFields();
      dataMap.getList();
    };

    const handleSizeChange = (val: number) => {
      dataMap.form.pageSize = val;
      dataMap.getList();
    };
    const handleCurrentChange = (val: number) => {
      dataMap.form.pageNum = val;
      dataMap.getList();
    };
    const dateChange = (val: any) => {
      dataMap.form.start = val[0] + "00:00:00";
      dataMap.form.end = val[1] + "23:59:59";
    };

    onMounted(() => {
      dataMap.getList();
    });

    return {
      locale,
      onSubmit,
      dateChange,
      resetForm,
      handleSizeChange,
      handleCurrentChange,
      ...toRefs(dataMap),
    };
  },
});
